export default __webpack_public_path__ + "static/media/video1.6dd8d54f.mp4";